(function () {
    'ngInject';

    angular.module('app.shared.services').factory('GeneralMathUtils', generalMathUtils);

    function generalMathUtils() {
        /**
         * Calculates the max and min font size limits of the object which are scaled proportionally
         *  from the object size. This function assumes the object is scaled proportionally and that
         *  the width and height can never change independently.
         */
        function calculateFontSizesFromObject(object) {
            return calculateFontSizesFromDimensions(
                object.getWidth(),
                object.originalWidth,
                object.originalMinSizePx,
                object.originalMaxSizePx
            );
        }

        function calculateCircularFontSizeFromDimensions(
            previewHorizontalDiameter,
            epsHorizontalDiameter,
            epsFontSize
        ) {
            return (previewHorizontalDiameter * epsFontSize) / epsHorizontalDiameter;
        }

        function calculateStrokeSizeFromObject(object) {
            return calculateStrokeSizeFromDimensions(object.getWidth(), object.originalWidth, object.getOutlineWidth());
        }

        function calculateInitTextValuesFromObject(object) {
            return calculateInitTextValues(
                object.getWidth(),
                object.originalWidth,
                object.originalInitCenterX,
                object.originalInitCenterY,
                object.originalInitFontSize,
            );
        }

        function calculateFontSizesFromDimensions(previewWidth, epsWidth, epsMinSizePx, epsMaxSizePx) {
            let newMinSizePx = (previewWidth * epsMinSizePx) / epsWidth;
            let newMaxSizePx = (previewWidth * epsMaxSizePx) / epsWidth;

            return {
                min: newMinSizePx,
                max: newMaxSizePx
            };
        }

        function calculateStrokeSizeFromDimensions(previewWidth, epsWidth, epsStrokePx) {
            return (previewWidth * epsStrokePx) / epsWidth;
        }

        function calculateInitTextValues(previewWidth, epsWidth, epsInitCenterX, epsInitCenterY, epsInitFontSize) {
            let newInitCenterX = (previewWidth * epsInitCenterX) / epsWidth;
            let newInitCenterY = (previewWidth * epsInitCenterY) / epsWidth;
            let newInitFontSize = (previewWidth * epsInitFontSize) / epsWidth;

            return {
                initCenterX: newInitCenterX,
                initCenterY: newInitCenterY,
                initFontSize: newInitFontSize
            };
        }

        return {
            calculateFontSizesFromObject: calculateFontSizesFromObject,
            calculateStrokeSizeFromObject: calculateStrokeSizeFromObject,
            calculateFontSizesFromDimensions: calculateFontSizesFromDimensions,
            calculateStrokeSizeFromDimensions: calculateStrokeSizeFromDimensions,
            calculateCircularFontSizeFromDimensions: calculateCircularFontSizeFromDimensions,
            calculateInitTextValuesFromObject: calculateInitTextValuesFromObject,
            calculateInitTextValues: calculateInitTextValues
        };
    }
})();
